import { useCallback } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import { INSPIRATION_CURRENCY } from "web_myplann/Inspiration/Utils/inspirationMoney";

export const useInspirationMoney = () => {
	const formatAmount = useFormatGoalAmount();

	return useCallback(
		(value: number) => formatAmount(value, INSPIRATION_CURRENCY),
		[formatAmount],
	);
};
